export default {
  computed: {
    tiivisNakyma () {
      return this.$store.state.user.tiivisNakyma
    },
  }
}
